<template>
	<view>
		<view class="cu-form-group margin-top">
			<view class="title">出库口</view>
			<picker @change="PickerChange" :value="index" :range="picker">
				<view class="picker">
					{{index>-1?picker[index]:'请选择'}}
				</view>
			</picker>
			<button></button>
		</view>
		<view>
			<button class="cu-btn bg-yellow pda-btn">确认</button>
			<button class="cu-btn bg-grey pda-btn">重置</button>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				picker: ['+补充', '汪汪汪', '哼唧哼唧'],
			}
		},
		methods: {
			
		}
	}
</script>

<style>
	
</style>
